import { IMetadataList } from 'source/NFR.types';

const MetadataList: React.FC<IMetadataList> = ({ title, items }) => {
  return (
    <div className="article-metadata">
      <h2 className="article-metadata--title">{title}</h2>
      <dl className="article-metadata--list">
        {items?.map(metadata => (
          <>
            <dt>{metadata.label}:</dt>
            {metadata.text?.map((paragraph, i) => (
              <dd key={i}>{paragraph}</dd>
            ))}
          </>
        ))}
      </dl>
    </div>
  );
};

MetadataList.displayName = 'MetadataList';

export default MetadataList;
